import { ApiUserLuat } from 'd3components';
import { getHost, getIam } from 'd3components/src/utils/request';

const { luatGetCaptcha, luatGenVcode } = ApiUserLuat;

declare global {
    interface Window {
        loadTAC?: any
    }
}
/**
 * 获取 Luat 租户图形验证码
 * @returns 返回图形验证码响应对象
 * ctxt 暂时不用
 */
export async function getLuatCaptcha(): Promise<any> {
    return await luatGetCaptcha()
}

/**
 * 发送验证码接口
 * @param withCtx 
 * @param data 
 * @returns 
 */
export async function  getSendCode(data) {
    return await luatGenVcode(data)
}

/**
 * 打开 Luatos TAC 图形校验，校验通过后通过 onSuccess 返回后端结果。
 */
export async function showLuatTacCaptcha(options: {
    bindEl: string
    phone: string
    onSuccess: (response: any) => void | Promise<void>
    onClose?: () => void
    onLoadError?: (error: any) => void
}) {
    if (!window.loadTAC) {
        const error = new Error('TAC 验证码脚本未加载')
        options.onLoadError?.(error)
        throw error
    }

    const baseUrl = getHost() + getIam()
    const types = ['WORD_IMAGE_CLICK', 'CONCAT', 'SLIDER', 'ROTATE']
    const randomType = types[Math.floor(Math.random() * types.length)]
    const captchaConfig = {
        requestCaptchaDataUrl: baseUrl + `generate_captcha?type=${randomType}`,
        validCaptchaUrl: baseUrl + `valid_captcha?user=${encodeURIComponent(options.phone)}`,
        bindEl: options.bindEl,
        validSuccess: async (res: any, _c: any, tac: any) => {
            tac.destroyWindow()
            await options.onSuccess(res)
        },
        validFail: (_res: any, _c: any, tac: any) => {
            tac.reloadCaptcha()
        },
        btnRefreshFun: (_el: any, tac: any) => tac.reloadCaptcha(),
        btnCloseFun: (_el: any, tac: any) => {
            tac.destroyWindow()
            options.onClose?.()
        },
    }

    return window.loadTAC('/tac', captchaConfig, {}).then((tac: any) => {
        tac.init()
        return tac
    }).catch((error: any) => {
        options.onLoadError?.(error)
        throw error
    })
}
